export function getAgeFromPersonalIdentificationNumber(
  personalIdentificationNumber: string,
): number | undefined {
  const match = personalIdentificationNumber.match(
    /^(\d{2})(\d{2})(\d{2})([+-])\d{4}$/,
  );

  if (!match) {
    return undefined;
  }

  const [, year, month, day, delimiter] = match;
  const today = new Date();
  const birthYear = resolveBirthYear(Number(year), delimiter!, today);
  const birthDate = new Date(birthYear, Number(month) - 1, Number(day));

  let age = today.getFullYear() - birthDate.getFullYear();
  const hasHadBirthdayThisYear =
    today.getMonth() > birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() &&
      today.getDate() >= birthDate.getDate());

  if (!hasHadBirthdayThisYear) {
    age -= 1;
  }

  return age;
}

function resolveBirthYear(
  twoDigitYear: number,
  delimiter: string,
  referenceDate: Date,
): number {
  const currentYear = referenceDate.getFullYear();
  const currentCentury = Math.floor(currentYear / 100) * 100;

  let recentBirthYear = currentCentury + twoDigitYear;
  if (recentBirthYear > currentYear) {
    recentBirthYear -= 100;
  }

  return delimiter === "+" ? recentBirthYear - 100 : recentBirthYear;
}
